import Immutable from 'seamless-immutable';
import _ from 'lodash';
import WinnerHistoryModel from './winner-history-model';

function create(winnerHistorys = []) {
  return Immutable(_.map(winnerHistorys, WinnerHistoryModel.create));
}

function deserialize(winnerHistorys = []) {
  return Immutable(_.map(winnerHistorys, WinnerHistoryModel.deserialize));
}

export default {
  create,
  deserialize,
};
